import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { ScarcityBar } from './ScarcityBar';
const items = [{
  title: '📘 Sistema ¿Qué Tejo Hoy?™',
  sub: '6 Tomos Digitales Premium · Más de 300 páginas',
  value: 'USD $97'
}, {
  title: '🎁 Bono 1 — “Nunca Más Te Quedes sin Lana”',
  sub: 'Calcula antes de empezar si realmente te alcanza la lana.',
  value: 'USD $17'
}, {
  title: '🎁 Bono 2 — La Fórmula de las Combinaciones Perfectas',
  sub: 'Más de 300 combinaciones de colores listas para usar.',
  value: 'USD $19'
}, {
  title: '🎁 Bono 3 — “Termina Todo lo que Empiezas”',
  sub: 'Recupera proyectos olvidados y conviértelos en prendas terminadas.',
  value: 'USD $21'
}, {
  title: '🎁 Bono 4 — La Biblioteca Secreta de los 100 Proyectos',
  sub: 'Inspiración organizada para cualquier momento.',
  value: 'USD $19'
}, {
  title: '🎁 Bono 5 — Teje para Regalar… o para Ganar Dinero',
  sub: 'Aprende cuáles tejidos tienen mayor demanda e ingresos extra.',
  value: 'USD $21'
}];
export function Offer() {
  return <section className="w-full bg-cream px-4 py-14" data-id="element-158" data-mp="zi4zhvwi3tvq">
      <div className="mx-auto max-w-2xl" data-id="element-159" data-mp="zgk9mjl4sz47">
        <div className="text-center" data-id="element-160" data-mp="13k9r6p3e2gfq">
          <span className="inline-block rounded-full bg-mauve px-4 py-1.5 text-sm font-extrabold text-white" data-id="element-161" data-mp="13j71gkhsyk1e">
            🏆 Oferta Especial de Lanzamiento
          </span>
          <h2 className="mt-4 font-display text-2xl font-black leading-tight text-plum-deep sm:text-3xl" data-id="element-162" data-mp="btltxo4u5v7c">
            Hoy puedes seguir haciendo lo de siempre…
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-plum/75" data-id="element-163" data-mp="klnpb801slar">
            Guardar más patrones. Comprar otro ovillo. Abrir Pinterest una vez
            más. Y seguir preguntándote:{' '}
            <em className="font-semibold text-plum" data-id="element-164" data-mp="3o9pf9cb83r1o">”¿Qué podría tejer hoy?”</em>
          </p>
          <p className="mt-3 text-sm font-semibold leading-relaxed text-mauve" data-id="element-165" data-mp="vfh2e1710hg6">
            O puedes decidir tus proyectos en menos de 2 minutos, empezar a
            disfrutar nuevamente del tejido y aprovechar toda la lana que ya
            tienes.
          </p>
        </div>

        {/* Value stack */}
        <div className="mt-8 overflow-hidden rounded-2xl bg-white shadow-lg ring-1 ring-mauve-soft/40" data-id="element-166" data-mp="105xlo1xj2xag">
          <div className="bg-plum px-5 py-3 text-center text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-167" data-mp="cg38fj9ar6po">
            Todo lo que recibes hoy
          </div>
          <ul className="divide-y divide-cream-2 px-5" data-id="element-168" data-mp="lhkv5kh7m6nc">
            {items.map(it => <li key={it.title} className="flex items-start gap-3 py-4" data-id="element-169" data-mp="lf86ypkuz01u">
                <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-sage" data-id="element-170" data-mp="heo7hfctbkcj" />
                <div className="flex-1" data-id="element-171" data-mp="1wvol8fkofan4">
                  <p className="text-sm font-bold text-plum" data-id="element-172" data-mp="1wykmacrtmffs">{it.title}</p>
                  <p className="text-xs text-plum/65" data-id="element-173" data-mp="1sulced11qeve">{it.sub}</p>
                </div>
                <span className="whitespace-nowrap text-sm font-bold text-plum/50" data-id="element-174" data-mp="20dule55n4bjx">
                  {it.value}
                </span>
              </li>)}
          </ul>
          <div className="flex items-center justify-between bg-cream-2 px-5 py-4" data-id="element-175" data-mp="1qh99r0z48274">
            <span className="text-sm font-extrabold text-plum" data-id="element-176" data-mp="1vf15k62vs8gl">
              Valor Total del Sistema
            </span>
            <span className="font-display text-xl font-black text-plum/50 line-through" data-id="element-177" data-mp="2j66jugt6asos">
              USD $194
            </span>
          </div>
        </div>

        {/* Price */}
        <div className="mt-8 text-center" data-id="element-178" data-mp="29fvcekaa61d5">
          <p className="text-sm text-plum/70" data-id="element-179" data-mp="29f261kf8hdvj">
            Pero hoy no pagarás USD $194. Ni USD $97. Ni siquiera USD $47.
          </p>
          <p className="mt-4 text-sm font-bold text-mauve" data-id="element-180" data-mp="3249dxa0kvftg">
            🏷️ Hoy puedes acceder por solo
          </p>
          <p className="font-display text-6xl font-black text-plum-deep sm:text-7xl" data-id="element-181" data-mp="36uziwm53dgnm">
            USD $12.99
          </p>
          <p className="mt-2 text-sm text-plum/70" data-id="element-182" data-mp="1j75zb2riba9s">
            Menos de lo que cuesta un ovillo premium. Y podrás usar este sistema
            durante años.
          </p>

          {/* Automatic currency note */}
          <div className="mx-auto mt-4 flex max-w-md items-center justify-center gap-2 rounded-full bg-sage/15 px-4 py-2 text-xs font-semibold text-sage" data-id="element-183" data-mp="198gtw9gsriaf">
            <GlobeIcon className="h-4 w-4" data-id="element-184" data-mp="21xfgbiryd6lj" />
            El cambio de moneda es automático según tu país.
          </div>
        </div>

        {/* Scarcity + Timer */}
        <div className="mt-8 space-y-6" data-id="element-185" data-mp="1x05h5berhgki">
          <ScarcityBar data-id="element-186" data-mp="1s6172ja78sf7" />
          <CountdownTimer data-id="element-187" data-mp="1s5i180xtpuhj" />
        </div>

        {/* CTA */}
        <div className="mx-auto mt-8 max-w-md" data-id="element-188" data-mp="1n8j55culndgp">
          <CtaButton data-id="element-189" data-mp="1n7pzygbagw0o" />
          <p className="mt-3 text-center text-xs font-semibold text-plum/70" data-id="element-190" data-mp="2kndixjcze7hs">
            Descarga inmediata · Pago único · Acceso de por vida · Garantía de 7
            días
          </p>
        </div>
      </div>
    </section>;
}